import { takeLatest, fork } from 'redux-saga/effects'

export function forkWatch(type, generator) {
  return fork(function* () {
    yield takeLatest(type, generator)
  })
}
